<template>
  <FormContainer>
    <template #title>{{ model?.sousDispositif === 'CDPI' ? 'Délégation' : 'Mission' }}</template>
    <template #content>
      <div class="form__bloc">
        <WrapperToggleSwitch
          id="field_mission"
          v-model="avecMissionModel"
          :label="
            model?.sousDispositif === 'CDPI'
              ? 'Une délégation a-t-il été réalisée?'
              : 'Une mission a-t-il été réalisée?'
          "
          :required="meta.mission?.avecMission?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.avecMission?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-9 col-md-18 col-sm-36"
        />
      </div>

      <div class="form__bloc">
        <WrapperInputDate
          v-if="meta.mission?.dateDebut?.$status !== PropertyStatus.NotPresent"
          id="field_dateDebutMission"
          v-model="dateDebutMissionModel"
          label="Date de début"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :required="meta.mission?.dateDebut?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.dateDebut?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInputDate
          v-else
          id="field_dateDebutMission"
          label="Date de début"
          :hint="HINT_DATE"
          :placeholder="PLACEHOLDER_DATE"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />

        <WrapperInputDate
          v-if="meta.mission?.dateFin?.$status !== PropertyStatus.NotPresent"
          id="field_dateFinMission"
          v-model="dateFinMissionModel"
          label="Date de fin"
          :hint="HINT_DATE"
          class="col-12 col-md-18 col-sm-36"
          :placeholder="PLACEHOLDER_DATE"
          :required="meta.mission?.dateFin?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.dateFin?.$messageErreurDirty!"
          :readonly
        />
        <WrapperInputDate
          v-else
          id="field_dateFinMission"
          label="Date de fin"
          :hint="HINT_DATE"
          :placeholder="PLACEHOLDER_DATE"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />
        <WrapperInputNumber
          v-if="meta.mission?.duree?.$status !== PropertyStatus.NotPresent"
          id="field_dureeMission"
          v-model="dureeMissionModel"
          label="Durée"
          hint="Durée de la mission en heures"
          :required="meta.mission?.duree?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.duree?.$messageErreurDirty!"
          :decimal="0"
          deletable
          :readonly
          class="col-12 col-md-18 col-sm-36"
        />
        <WrapperInputNumber
          v-else
          id="field_dureeMission"
          label="Durée"
          hint="Durée de la mission en heures"
          class="col-12 col-md-18 col-sm-36"
          disabled
        />
      </div>

      <div class="form__bloc">
        <WrapperInput
          v-if="meta.mission?.posteOccupe?.$status !== PropertyStatus.NotPresent"
          id="field_posteOccupe"
          v-model="posteOccupeModel"
          label="Poste occupé"
          hint="100 caractères maximum"
          class="col-27 col-md-18 col-sm-36"
          :required="meta.mission?.posteOccupe?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.posteOccupe?.$messageErreurDirty!"
          :maxlength="100"
          deletable
          :readonly
        />
        <WrapperInput
          v-else
          id="field_posteOccupe"
          label="Poste occupé"
          hint="100 caractères maximum"
          class="col-27 col-md-18 col-sm-36"
          disabled
        />
        <WrapperToggleSwitch
          v-if="meta.mission?.avecTransport?.$status !== PropertyStatus.NotPresent"
          id="field_avecTransport"
          v-model="avecTransportModel"
          label="Transport routier?"
          :required="meta.mission?.avecTransport?.$status === PropertyStatus.Required"
          :alertLabel="meta.mission?.avecTransport?.$messageErreurDirty!"
          :items="OuiOuNon"
          :readonly
          class="col-9 col-md-18 col-sm-36"
        />
        <WrapperToggleSwitch
          v-else
          id="field_avecTransport"
          label="Transport routier?"
          :items="OuiOuNon"
          :readonly
          class="col-9 col-md-18 col-sm-36"
          disabled
        />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { HINT_DATE, PLACEHOLDER_DATE } from '@/features/interface/demande/shared'
  import { DEMANDE_STORE } from '@/features/interface/demande/shared/components'
  import FormContainer from '@/features/interface/demande/shared/components/FormContainer.vue'
  import { OuiOuNon } from '@/features/interface/shared/tools'
  import { WrapperInputDate, WrapperToggleSwitch } from '@designSystem/index'
  import { storeToRefs } from 'pinia'
  import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_DR'>()
  const { meta, readonly, model } = storeToRefs(store)
  const { setupFieldWithKey } = store

  const dateDebutMissionModel = setupFieldWithKey<string>('mission.dateDebut', true)
  const dateFinMissionModel = setupFieldWithKey<string>('mission.dateFin', true)

  const dureeMissionModel = setupFieldWithKey<number>('mission.duree', true)
  const posteOccupeModel = setupFieldWithKey<string>('mission.posteOccupe', true)

  const avecMissionModel = setupFieldWithKey<boolean>('mission.avecMission', true)

  const avecTransportModel = setupFieldWithKey<boolean>('mission.avecTransport', true)
</script>
